import { Send } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { errText, frDateTime } from "@/components/prospect/common";
import { fillVars } from "@/components/prospect/CallScriptRunner";

export function ContactEmail({ row, fileId, onSent }) {
  const [templates, setTemplates] = useState(null);
  const [mail, setMail] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (mail && !templates) api.get("/prospect/email-templates").then(({ data }) => setTemplates(data)).catch(() => setTemplates([])); }, [mail, templates]);
  useEffect(() => setMail(null), [row.id]);
  const pick = (id) => { const t = templates.find((x) => x.id === id); if (t) setMail({ subject: fillVars(t.subject, row), body: fillVars(t.body, row) }); };
  const send = async () => {
    setBusy(true);
    try { await api.post(`/prospect/files/${fileId}/rows/${row.id}/email`, mail); toast.success(`E-mail envoyé à ${row.email}.`); onSent({ last_email_at: new Date().toISOString(), emails: (row.emails || 0) + 1 }); setMail(null); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  if (!row.email) return null;
  return (
    <section className="ps-card" data-testid="contact-email">
      <h3>E-mail {row.last_email_at && <small className="pl-muted" data-testid="contact-last-email">dernier envoi {frDateTime(row.last_email_at)}</small>}</h3>
      {!mail
        ? <button type="button" className="secondary-button" onClick={() => setMail({ subject: "", body: "" })} data-testid="contact-email-open"><Send size={14} /> Écrire un e-mail</button>
        : (
          <div className="ps-mail">
            <select defaultValue="" onChange={(e) => pick(e.target.value)} data-testid="contact-email-template">
              <option value="">{templates === null ? "Chargement des modèles…" : templates.length ? "Choisir un modèle…" : "Aucun modèle (Automatisations › Modèles)"}</option>
              {(templates || []).map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
            <input value={mail.subject} onChange={(e) => setMail({ ...mail, subject: e.target.value })} placeholder="Objet" data-testid="contact-email-subject" />
            <textarea rows={6} value={mail.body} onChange={(e) => setMail({ ...mail, body: e.target.value })} placeholder="Message" data-testid="contact-email-body" />
            <div className="ps-mail-actions">
              <button type="button" className="link-button" onClick={() => setMail(null)} data-testid="contact-email-cancel">Annuler</button>
              <button type="button" className="primary-button" disabled={busy || !mail.subject.trim() || !mail.body.trim()} onClick={send} data-testid="contact-email-send"><Send size={14} /> {busy ? "Envoi…" : `Envoyer à ${row.email}`}</button>
            </div>
          </div>
        )}
    </section>
  );
}
